import { useSearchParams, useNavigate } from "react-router-dom";
import { XCircle, Landmark } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const filingId = params.get("filing_id");

  return (
    <div className="min-h-screen flex flex-col">
      <div className="civic-hero py-6">
        <div className="max-w-6xl mx-auto px-6 flex items-center gap-3 text-white">
          <span className="w-9 h-9 rounded-md bg-white/15 flex items-center justify-center">
            <Landmark className="w-5 h-5" />
          </span>
          <div className="leading-tight">
            <p className="font-heading font-semibold text-sm">Cheltenham Township</p>
            <p className="text-xs text-slate-200">Tax Filing Portal</p>
          </div>
        </div>
      </div>
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="w-full max-w-md bg-white border border-slate-200 rounded-md p-10 text-center" data-testid="payment-cancel-card">
          <span className="w-16 h-16 rounded-full bg-amber-50 flex items-center justify-center mx-auto">
            <XCircle className="w-9 h-9 text-amber-600" />
          </span>
          <h1 className="font-heading text-2xl font-semibold text-slate-900 mt-6">
            Payment cancelled
          </h1>
          <p className="text-slate-500 mt-2">
            No charge was made. Your filing is saved and you can pay the balance any time.
          </p>
          <div className="flex gap-3 mt-6">
            {filingId && (
              <Button
                onClick={() => navigate(`/filing/${filingId}`)}
                className="flex-1 bg-[#1E3A8A] hover:bg-[#1E40AF] text-white"
                data-testid="cancel-back-filing"
              >
                Back to Filing
              </Button>
            )}
            <Button
              variant="outline"
              onClick={() => navigate("/dashboard")}
              className="flex-1 border-slate-300"
            >
              My Filings
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
